export { SpotlightHero } from './SpotlightHero'
